import { RestaurantIcon, ShoppingBagOutlinedIcon } from "../components/icons";
import { useDispatch, useSelector } from "react-redux";
import { setInLocoAnswer } from "../ducks/checkoutSlice";

export default function InLocoForm() {
  const dispatch = useDispatch();
  const { isTakingHome } = useSelector((state) => state.checkout);

  const setTakingHome = (value) => {
    dispatch(
      setInLocoAnswer({
        name: "isTakingHome",
        value,
      }),
    );
  };

  const options = [
    { value: false, icon: <RestaurantIcon />, title: "Vou comer aqui" },
    {
      value: true,
      icon: <ShoppingBagOutlinedIcon />,
      title: "Embalar para viagem",
    },
  ];

  return (
    <div className="delivery-selection">
      <div className="mode-options" role="radiogroup" aria-label="Como vai ser">
        {options.map((option) => {
          const selected = !!isTakingHome === option.value;
          return (
            <button
              key={option.title}
              type="button"
              role="radio"
              aria-checked={selected}
              className={`mode-option${selected ? " is-selected" : ""}`}
              onClick={() => setTakingHome(option.value)}
            >
              <span className="mode-option__icon">{option.icon}</span>
              <span className="mode-option__title">{option.title}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
